import React from 'react';

import { LoadableAfterPaint } from '@confluence/loadable';

import { EmojiPlaceholder } from '../src/EmojiPlaceholder.tsx';

export const LazyEmojiComponentLoader = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-srcEmojiComponent" */ '../src/EmojiComponent.tsx'))
			.EmojiComponent,
	loading: (props) => (props.emoji ? <EmojiPlaceholder {...props} /> : null),
});
